/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Active_BadgeInputs */



/**
* | output |
* | --- |
* | "Active media version" |
*
* @param {Media_Tab_Active_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_active_badge = /** @type {((inputs?: Media_Tab_Active_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Active_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Version média active")
	if (locale === "de") return /** @type {LocalizedString} */ ("Active Media-Version")
	if (locale === "it") return /** @type {LocalizedString} */ ("Versione multimediale attiva")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Версия с активными медиафайлами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Versión multimedia activa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动媒体版本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティブメディア版")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सक्रिय मीडिया संस्करण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Versão de mídia ativa")
	return /** @type {LocalizedString} */ ("Active media version")
});